(() => {
  'use strict';
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const motionButton = document.querySelector('button[data-ob-motion]');
  let userPaused = false;
  try { userPaused = sessionStorage.getItem('ob-motion') === 'paused'; } catch {}
  const applyMotion = () => {
    const paused = userPaused || reduced.matches;
    root.dataset.obMotion = paused ? 'paused' : 'playing';
    if (motionButton) {
      motionButton.setAttribute('aria-pressed', String(paused));
      motionButton.setAttribute('aria-label', paused ? document.body.dataset.playLabel : document.body.dataset.pauseLabel);
      motionButton.innerHTML = paused ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 5 11 7-11 7Z"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6v12M15 6v12"/></svg>';
    }
    document.dispatchEvent(new CustomEvent('ob:motion', { detail: { paused } }));
  };
  motionButton?.addEventListener('click', () => {
    userPaused = !userPaused;
    try { sessionStorage.setItem('ob-motion', userPaused ? 'paused' : 'playing'); } catch {}
    applyMotion();
  });
  reduced.addEventListener('change', applyMotion);
  applyMotion();

  const menu = document.querySelector('[data-ob-menu]');
  const navigation = document.getElementById('ob-mobile-nav');
  const closeMenu = () => { if (navigation) navigation.hidden = true; menu?.setAttribute('aria-expanded', 'false'); };
  menu?.addEventListener('click', () => {
    const opened = menu.getAttribute('aria-expanded') === 'true';
    menu.setAttribute('aria-expanded', String(!opened));
    navigation.hidden = opened;
  });
  navigation?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && navigation && !navigation.hidden) { closeMenu(); menu.focus(); } });
  document.addEventListener('click', e => { if (navigation && !navigation.hidden && !navigation.contains(e.target) && !menu.contains(e.target)) closeMenu(); });
  matchMedia('(min-width: 801px)').addEventListener('change', e => { if (e.matches) closeMenu(); });

  const progress = document.querySelector('.ob-scroll-progress span');
  const hero = document.querySelector('.ob-hero-title');
  let scrollQueued = false;
  const updateScroll = () => {
    scrollQueued = false;
    const max = Math.max(1, root.scrollHeight - innerHeight);
    if (progress) progress.style.transform = `scaleX(${Math.min(1, scrollY / max)})`;
    if (hero && root.dataset.obMotion !== 'paused') hero.style.transform = `translateY(${Math.min(scrollY, innerHeight) * .13}px)`;
    else if (hero) hero.style.transform = '';
  };
  addEventListener('scroll', () => { if (!scrollQueued) { scrollQueued = true; requestAnimationFrame(updateScroll); } }, { passive: true });
  addEventListener('resize', updateScroll, { passive: true });
  document.addEventListener('ob:motion', updateScroll);
  updateScroll();

  if ('IntersectionObserver' in window) {
    const links = [...document.querySelectorAll('[data-ob-chapter-link]')];
    const chapters = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      links.forEach(link => {
        if (link.dataset.obChapterLink === entry.target.dataset.obChapter) link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    }), { rootMargin:'-15% 0px -55% 0px', threshold:0 });
    document.querySelectorAll('[data-ob-chapter]').forEach(section => chapters.observe(section));
  }

  if ('IntersectionObserver' in window && !reduced.matches) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('ob-visible'); observer.unobserve(entry.target); }
    }), { rootMargin: '0px 0px 30px 0px', threshold: .04 });
    document.querySelectorAll('[data-ob-reveal]').forEach(el => {
      if (el.getBoundingClientRect().top < innerHeight) el.classList.add('ob-visible');
      else observer.observe(el);
    });
    root.classList.add('ob-reveal-ready');
  }
  const finePointer = matchMedia('(hover:hover) and (pointer:fine)');
  document.querySelectorAll('[data-ob-tilt]').forEach(card => {
    card.addEventListener('pointermove', e => {
      if (!finePointer.matches || root.dataset.obMotion === 'paused') return;
      const b = card.getBoundingClientRect();
      card.style.setProperty('--tilt-x', `${((e.clientX - b.left) / b.width - .5) * 4}deg`);
      card.style.setProperty('--tilt-y', `${-((e.clientY - b.top) / b.height - .5) * 3}deg`);
    });
    card.addEventListener('pointerleave', () => { card.style.removeProperty('--tilt-x'); card.style.removeProperty('--tilt-y'); });
  });

  document.querySelectorAll('[data-ob-copy]').forEach(button => button.addEventListener('click', async () => {
    try {
      const url = new URL(location.href);
      url.search = ''; url.hash = '';
      await navigator.clipboard.writeText(url.href);
      button.textContent = button.dataset.copied;
      setTimeout(() => { button.textContent = button.dataset.label + ' ↗'; }, 2500);
    } catch { button.textContent = location.origin + location.pathname; }
  }));

  const mainImage = document.getElementById('ob-gallery-main');
  document.querySelectorAll('[data-ob-image]').forEach(button => button.addEventListener('click', () => {
    if (!mainImage) return;
    mainImage.removeAttribute('srcset');
    mainImage.src = button.dataset.obImage;
    document.querySelectorAll('[data-ob-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
  }));
  const variantSelect = document.getElementById('ob-variant');
  const addButton = document.querySelector('[data-ob-add]');
  variantSelect?.addEventListener('change', () => {
    const option = variantSelect.selectedOptions[0];
    const available = option.dataset.available === 'true';
    document.querySelector('[data-ob-price]').textContent = option.dataset.price;
    addButton.disabled = !available;
    addButton.innerHTML = (available ? addButton.dataset.label : addButton.dataset.sold) + ' <span>↗</span>';
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState(null, '', url);
  });

  const description = document.getElementById('ob-details');
  const sizing = document.getElementById('ob-sizing');
  const tablist = document.querySelector('.ob-tabs');
  if (description && sizing && tablist) {
    const headings = [...description.querySelectorAll('h1,h2,h3,h4,p,strong')];
    const heading = headings.find(el => /^\s*size\s+(guide|chart)\s*:?\s*$/i.test(el.textContent));
    if (heading) {
      let boundary = heading;
      while (boundary.parentElement !== description && boundary.parentElement) boundary = boundary.parentElement;
      let node = boundary;
      let moved = 0;
      while (node) { const next = node.nextSibling; sizing.append(node); moved++; node = next; }
      if (moved) sizing.querySelector('[data-ob-sizing-fallback]')?.remove();
    } else {
      const tables = [...description.querySelectorAll('table')];
      tables.forEach(table => { sizing.append(table); });
      if (tables.length) sizing.querySelector('[data-ob-sizing-fallback]')?.remove();
    }
    description.setAttribute('role', 'tabpanel'); description.setAttribute('aria-labelledby', 'ob-details-tab');
    sizing.setAttribute('role', 'tabpanel'); sizing.setAttribute('aria-labelledby', 'ob-sizing-tab');
    const tabs = [...tablist.querySelectorAll('[role=tab]')];
    const panels = [description, sizing];
    const select = index => {
      tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index));
      tab.addEventListener('keydown', e => {
        let next;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') next = 1 - index;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = 1;
        else return;
        e.preventDefault(); select(next); tabs[next].focus();
      });
    });
    tablist.hidden = false;
    select(0);
  }
})();
